export default __webpack_public_path__ + "static/media/Coin.9a439c13.svg";